import { useState, useEffect, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
//import moment from 'moment';
import { AppTokenModel, DynamicObjectInterface } from '../../../sdk/type';
import {
  ButtonStyles,
  Input,
  InputTypes,
  MLPVersion,
  Theme,
  DropDown,
  IconStyle,
  IconPropInterface,
  ButtonIconPosition,
  ButtonSize,
  ButtonPropsTypes,
  Modal,
  TextAlign,
  Button,
  ButtonTypes,
  useBreakpoint,
  FAIcon,
} from '../../../ui/components';
import { DropDownData } from '../../../ui/components/Form/DropDown/types/propsType';
import { dateTimeToCustomFormat, PAGES, trackPage } from '../../../ui/utils';
import { useAdminToast } from '../../../ui/components/AdminToast/AdminToast';
import EnrollmentService from '../../../sdk/services/enrollmentService';
import CampaignService from '../../../sdk/services/campaignService';
import CoachService from '../../../sdk/services/coachService';
import ParticipantService from '../../../sdk/services/participantService';
import { useAPICall } from '../../../hooks';
import CoachEnrollmentImage from '../../../assets/image/operationCard/Coach_Enrollment.png';
import styles from './index.module.scss';

export interface CoachEnrollmentData {
  campaignId?: string;
  campaignName?: string;
  validity?: number;
  coachId?: string;
  aboId?: string;
  userName?: string;
  enrollmentType?: string;
  name?: string;
  enrollmentDate?: Date;
  endDate?: Date;
  period?: [Date, Date];
  status?: string;
  remark?: string;
  phone?: string;
  email?: string;
  startMonth?: string;
  leaderPinCriteria?: number | undefined | null;
  campaignRecId?: number;
  pin?: number;
  highestPin?: number;
}

export interface CampaignData {
  recId: number;
  campaignId: string;
  campaignName: string;
  validity: number;
  status: string;
  campaignStart: Date;
  campaignEnd: Date;
}

interface CoachEnrollmentProps {
  decodedData: AppTokenModel | null;
}

export const CoachEnrollment = (props: CoachEnrollmentProps) => {
  const { t } = useTranslation();
  const { adminToast } = useAdminToast();
  const [data, setData] = useState<CoachEnrollmentData | null>(null);
  const [campaignDropdownData, setCampaignDropdownData] = useState<DropDownData[]>([]);
  const [campaignData, setCampaignData] = useState<CampaignData[]>([]);
  const [invalid, setInvalid] = useState(true);
  const [showNotification, setShowNotification] = useState(false);
  const [validateUser, setValidateUser] = useState(false);

  const ranOnce = useRef(false);
  const apiCall = useAPICall();

  const viewPortType = useBreakpoint();
  const isDesktopView = ['xs', 'sm', 'md'].indexOf(viewPortType) === -1;

  useEffect(() => {
    (async () => {
      if (!ranOnce.current && props.decodedData?.loginId) {
        ranOnce.current = true;
        let res = await apiCall(CoachService?.getCoachByAboId, props.decodedData?.loginId);

        setData({
          aboId: props.decodedData?.loginId,
          userName: props.decodedData?.name,
          coachId: res?.data?.data?.coachID,
          name: res?.data?.data?.name,
          email: res?.data?.data?.email,
          phone: res?.data?.data?.contact,
          //enrollmentDate: new Date(moment(new Date()).startOf('month').toString()),
        });

        let res2 = await apiCall(CampaignService?.getCampaigns);
        let campaignData = res2?.data?.data ?? [];
        setCampaignData(
          campaignData?.filter(
            (i: DynamicObjectInterface) =>
              i.status !== 'DELETED' && i.status !== 'CLOSED' && i.campaignId === res?.data?.data?.campaignId,
          ),
        );

        setCampaignDropdownData(
          campaignData
            ?.filter(
              (i: DynamicObjectInterface) =>
                i.status !== 'DELETED' && i.status !== 'CLOSED' && i.campaignId === res?.data?.data?.campaignId,
            )
            .map((d: DynamicObjectInterface) => ({
              value: d.campaignId,
              title: `${d.campaignId} - ${d.campaignName}`,
              campaignRecId: d.recId,
            })),
        );
      }
    })();

    const timeout = setTimeout(() => {
      trackPage(PAGES.coachEnrollment);
    }, 1000);
    return () => {
      clearTimeout(timeout);
    };
  }, [props.decodedData]);

  useEffect(() => {
    validateInputs();
  }, [data]);


  useEffect(() => {
    (async () => {
      let res = await apiCall(CampaignService?.getCampaigns);
      let campaignData = res?.data?.data ?? [];
      setCampaignData(
        campaignData?.filter((i: DynamicObjectInterface) => i.status !== 'DELETED' && i.status !== 'CLOSED'),
      );

      setCampaignDropdownData(
        campaignData
          ?.filter((i: DynamicObjectInterface) => i.status !== 'DELETED' && i.status !== 'CLOSED')
          .map((d: DynamicObjectInterface) => ({
            value: d.campaignId,
            title: `${d.campaignId} - ${d.campaignName}`,
            campaignRecId: d.recId,
          })),
      );
    })();
  }, []);

  useEffect(() => {
    if (data?.campaignRecId) {
      validateCoach();
    }
  }, [data?.campaignRecId]);

  const validateCoach = async () => {
    const response = await apiCall(ParticipantService.validatePin, {
      campaignRecId: data?.campaignRecId,
    });
    setValidateUser(response?.data?.data?.qualifiedAsCoach);
    setData(data => ({
      ...data,
      pin: response?.data?.data?.pin,
      highestPin: response?.data?.data?.highestPin,
    }));
  };


  const handleInputChange = async (name: string, value: DynamicObjectInterface) => {
    // if (name === 'enrollmentDate') {
    //   value = moment(value).startOf('month').toString();
    //   const toDate = moment(value)
    //     .add(data?.validity ? data.validity - 1 : 0, 'months')
    //     .endOf('month')
    //     .toString();
    //   setData(prevData => ({
    //     ...prevData!,
    //     endDate: new Date(toDate),
    //   }));
    // }

    if (name === 'campaignId') {
      const campaignRecId = campaignData?.find(r => r.campaignId === value)?.recId;
      let validity = 0;
      let leaderPinCriteria: null = null;
      let enrollmentDate = campaignData?.find(r => r.campaignId === value)?.campaignStart;
      let endDate = campaignData?.find(r => r.campaignId === value)?.campaignEnd;

      if (campaignRecId) {
        let res = await apiCall(CampaignService?.getCampaignDetail, campaignRecId?.toString());
        validity = res?.data?.data.activities?.coach?.validity?.value;
        leaderPinCriteria = res?.data?.data.activities?.leader?.pin?.[0]?.pinId;
      }

      setData(prevData => ({
        ...prevData!,
        campaignName: campaignData.find(r => r.campaignId === value)?.campaignName ?? '',
        validity: validity,
        leaderPinCriteria: leaderPinCriteria,
        enrollmentDate: enrollmentDate,
        endDate: endDate,
      }));

      // if (data?.enrollmentDate) {
      //   const toDate = moment(data?.enrollmentDate)
      //     .add(validity ? validity - 1 : 0, 'months')
      //     .endOf('month')
      //     .toString();
      //   setData(prevData => ({
      //     ...prevData!,
      //     endDate: new Date(toDate),
      //   }));
      // }
    }
    setData(prevData => ({
      ...prevData!,
      [name]: value,
    }));
  };

  const onSave = async () => {
    const payload = {
      campaignId: data?.campaignId,
      aboId: data?.aboId,
      enrollmentDate: data?.enrollmentDate
        ? dateTimeToCustomFormat(data?.enrollmentDate?.toString(), 'YYYY-MM-DD')
        : null,
      endDate: data?.endDate ? dateTimeToCustomFormat(data?.endDate?.toString(), 'YYYY-MM-DD') : null,
      enrollmentType: 'COACH',
      remark: data?.remark,
      status: data?.status,
      coachId: data?.coachId,
      userName: data?.userName,
      rollingMonth: data?.validity,
      pinLevel: data?.pin,
      highestPinLevel: data?.highestPin,
    };

    let result = await apiCall(EnrollmentService.createEnrollment, payload);
    if (result.status === 200 && result?.data?.status) {
      setShowNotification(true);
    } else {
      adminToast({
        message: 'Failed to save Coach Enrollment. ' + result?.data?.message,
        theme: Theme.ERROR,
      });
    }
  };

  const getButtonConfig = useMemo(() => {
    return {
      submitCoachEnrollment: [
        {
          title: 'Submit',
          icon: {
            iconName: 'file-export',
            iconStyle: IconStyle.SOLID,
          } as IconPropInterface,
          iconPosition: ButtonIconPosition.LEFT,
          buttonStyle: ButtonStyles.SOLID,
          theme: Theme.BLACK,
          size: ButtonSize.SMALL,
          disabled: invalid,
          onClick: () => {
            onSave();
          },
        },
      ],
    } as { [index: string]: ButtonPropsTypes[] };
  }, [invalid, data]);

  const validateInputs = () => {
    const { campaignId, campaignRecId, enrollmentDate } = data ?? {};
    const isAnyFieldEmpty = !campaignId || !campaignRecId || !enrollmentDate || !validateUser;
    setInvalid(isAnyFieldEmpty);
  };

  const notificationPrompt = (
    <>
      {showNotification && (
        <Modal
          primaryButtonLabel={''}
          containerWidth={'max-content'}
          headline={''}
          closeIcon={false}
          textAlign={TextAlign.CENTER}
          primaryButton={
            <Button
              title={'Close'}
              type={ButtonTypes.BUTTON}
              onClick={() => {
                setShowNotification(false);
                window.location.href = `/campaigns/${data?.campaignId}`;
              }}
              size={ButtonSize.SMALL}
              buttonStyle={ButtonStyles.SOLID}
              data-testid="test-add-button-popup"
            />
          }
        >
          <div className={styles['modal-container']}>
            <div className={styles['modal-img']}>
              <img src={CoachEnrollmentImage} alt={`coachEnrollmentImage`} width="300px" />
            </div>
            <div className={styles['modal-headline']}>Congratulations!</div>
            <div className={styles['modal-desc']}>You have been successfully declared as a Coach. </div>
          </div>
        </Modal>
      )}
    </>
  );

  return (
    <div className={styles['edit-team']}>
      <div className={styles['card']}>
        <div className={styles['card-header']}>
          <h2>Coach Enrollment</h2>
          {isDesktopView && (
            <>
              <div className={styles['actions-container']}>
                {getButtonConfig.submitCoachEnrollment.map(btn => (
                  <Button key={btn.title} size={ButtonSize.SMALL} {...btn} />
                ))}
              </div>
            </>
          )}
        </div>
        <div className={styles['create-team-form-container']}>
          <div className={styles['dropdown-wrapper']}>
            <DropDown
              name="campaignId"
              dropdownLabel={`Campaign`}
              required={true}
              disabledFilter={false}
              placeholder="Select a campaign"
              mlpVersion={MLPVersion.ONE}
              value={
                (
                  campaignDropdownData?.find((c: DynamicObjectInterface) => c.value === data?.campaignId) as
                    | DynamicObjectInterface
                    | undefined
                )?.title ?? ''
              }
              data={campaignDropdownData}
              configData={{
                label: 'title',
                onSelect: (selectedOption: DropDownData) => {
                  handleInputChange('campaignId', selectedOption.value);
                  handleInputChange('campaignRecId', selectedOption.campaignRecId);
                },
              }}
              readOnly={false}
            />

            { data?.pin === undefined  && !!data?.campaignRecId ? (
              <div className={styles['validate-user-container']}>
                <FAIcon theme={Theme.WARNING} iconName="exclamation-circle" iconStyle={IconStyle.SOLID} />
                <div
                  className={styles['error-text']}
                >{`Oops! An unexpected error has occurred. Please try again later, or contact Customer Service for support.`}</div>
              </div>
            ) : (
              !validateUser && (
                <div className={styles['validate-user-container']}>
                  <FAIcon theme={Theme.WARNING} iconName="exclamation-circle" iconStyle={IconStyle.SOLID} />
                  <div
                    className={styles['error-text']}
                  >{`Oops! Our records indicate you do not fulfil the conditions for coach enrollment. If you believe this is in error, please contact Customer Service for support.`}</div>
                </div>
              )
            )}
          </div>
          <Input
            type={InputTypes.TEXT}
            name={'coachId'}
            label={`${t('admin.coachEnrollmentMaster.coachId')}`}
            value={data?.coachId}
            mlpVersion={MLPVersion.ONE}
            disabled={true}
          />

          <Input
            type={InputTypes.TEXT}
            name={'aboId'}
            label={`ABO No.`}
            value={data?.aboId}
            mlpVersion={MLPVersion.ONE}
            disabled={true}
          />
        </div>

        <div className={styles['create-team-form-container']}>
          <Input
            type={InputTypes.TEXT}
            name={'name'}
            label={`Name`}
            value={data?.name}
            mlpVersion={MLPVersion.ONE}
            disabled={true}
          />

          <Input
            type={InputTypes.TEXT}
            name={'email'}
            label={`Email`}
            value={data?.email}
            mlpVersion={MLPVersion.ONE}
            disabled={true}
          />

          <Input
            type={InputTypes.TEXT}
            name={'phone'}
            label={`Mobile No.`}
            value={data?.phone}
            mlpVersion={MLPVersion.ONE}
            disabled={true}
          />
        </div>
        <div className={styles['create-team-form-container']}>
          <div>
            <div className={styles['status-label']}>Status</div>
            <div className={styles['status-value']}>ACTIVE</div>
          </div>
        </div>

        <div className={styles['create-team-form-container']}>
          <Input
            type={InputTypes.TEXT}
            name={'remark'}
            label={`Remarks(if any)`}
            placeholder="Remarks"
            value={data?.remark}
            mlpVersion={MLPVersion.ONE}
            onChange={e => {
              handleInputChange('remark', e.target.value);
            }}
          />
        </div>
        {!isDesktopView && (
          <>
            <div className={styles['actions-container']}>
              {getButtonConfig.submitCoachEnrollment.map(btn => (
                <Button key={btn.title} size={ButtonSize.SMALL} {...btn} />
              ))}
            </div>
          </>
        )}
        {notificationPrompt}
      </div>
    </div>
  );
};
